import store from '@/store'
export default [
  {
    path: '/product-locations',
    name: 'product-location',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product-location/index.vue'),
    beforeEnter: (to, from, next) => {
      store.dispatch('productLocation/dataBeforeCreate')
      next()
    }
  },
  {
    path: '/product-locations/create',
    name: 'product-location-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/product-location/create.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('productLocation/dataBeforeCreate')
      next()
    }
  }
]
